import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { DLModal } from 'appSrc/components/Shards';
import { dAPI } from 'appSrc/api';
import BrandForm from './BrandForm';
import LoadingOverlay from 'appSrc/components/Shards/Loading/Overlay';


class NewBrandModal extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            fetching: false,
        };
    }

    submitHandler = ( brand ) => {
        this.setState( { fetching: true } );
        this.props.createBrand( brand )
        .then( ( newBrand ) => {
            this.setState( { fetching: false } );
            this.props.onSubmit && this.props.onSubmit( newBrand );
        } );
    }

    render() {
        const initialValues = { };
        return (
            <DLModal title='New Brand'
            closeHandler={ this.props.closeModal }>
                <div>
                    <BrandForm onSubmit={ this.submitHandler } initialValues={ initialValues } />
                </div>
                { this.state.fetching &&
                    <LoadingOverlay />
                }
            </DLModal>
        );
    }

}
const mapDispatchToProps = () => {
    return {
        createBrand: ( data ) => {
            return dAPI.post( '/admin/brands', data );

        },
        updateBrand: ( id, data ) => {
            return dAPI.patch( `/admin/brands/${ id }`, data );

        },
    };
};

export default connect( null, mapDispatchToProps )( NewBrandModal );
